import React, { useState } from "react";

const PaymentModal = ({ show, onClose, onSelectPayment }) => {
    const [showMultipleOptions, setShowMultipleOptions] = useState(false);

    return (
        <div className={`modal fade bg-light-transparent ${show ? "show d-block" : "d-none"}`} tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Select Payment Method</h5>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>
                    <div className="modal-body text-center">
                        <p>Choose how the customer wants to pay:</p>

                        {/* Show Single Mode options only if showMultipleOptions is false */}
                        {!showMultipleOptions && (
                            <>
                                <button className="btn btn-success mx-2" onClick={() => onSelectPayment(2)}>
                                    Credit
                                </button>
                                <button className="btn btn-primary mx-2" onClick={() => onSelectPayment(1)}>
                                    Cash
                                </button>
                                <button className="btn btn-warning mx-2" onClick={() => onSelectPayment(4)}>
                                    Card
                                </button>
                                <button className="btn btn-dark mx-2" onClick={() => onSelectPayment(5)}>
                                    Cash & Card
                                </button>
                            </>
                        )}

                        {/* Toggle Multiple Mode Options */}
                        <button
                            className="btn btn-dark mx-2 d-none"
                            onClick={() => setShowMultipleOptions(!showMultipleOptions)}
                        >
                            {showMultipleOptions ? "Single Mode" : "Multiple Mode"}
                        </button>

                        {/* Multiple Mode Options - Show only when showMultipleOptions is true */}
                        {showMultipleOptions && (
                            <div className="mt-3">
                                <button className="btn btn-outline-primary m-1" onClick={() => onSelectPayment(5)}>
                                    Cash & Card
                                </button>
                                <button className="btn btn-outline-success m-1" onClick={() => onSelectPayment(6)}>
                                    Cash & Credit
                                </button>
                                <button className="btn btn-outline-warning m-1" onClick={() => onSelectPayment(7)}>
                                    Card & Credit
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentModal;
